import Vue from 'vue'

Vue.filter('local', function(value) {
  if (!isNaN(value)) {
    return new Number(value).toLocaleString('ru-RU')
  } else return value
})

Vue.filter('roubles', function(money) {
  return money.toLocaleString('ru-RU') + ' ₽'
})

Vue.filter('date', function(timestamp) {
  return new Date(timestamp).toLocaleDateString('ru-RU')
})
